(function(window, angular, undefined) {
	angular.module('formApp')
	.service('formData', function() {
		return  {
            pets: [{}],
            cover: {},
            aboutYou: {},
            charitableDonation: {},
            declarations: {},
            totals: {}
        };
	});       
})(window, window.angular);